import { render } from "./TopRanking.vue?vue&type=template&id=edcab8c6"
import script from "./TopRanking.vue?vue&type=script&lang=js"
export * from "./TopRanking.vue?vue&type=script&lang=js"
script.render = render

export default script